export default __webpack_public_path__ + "resources/icons/d441-e79c.png";